module.exports = __webpack_public_path__ + "img/myposition_cb_버질 반 다이크.dbfe7889.png";